export const TickSection = () => {
  return (
    <div>
      Hello World
    </div>
  )
};